import {
    Model
} from '@vuex-orm/core'

export default class Beacon extends Model {
    
    static entity = 'beacons'

    static fields() {
        return {
            id: this.attr(null),
            name: this.attr(''),
            factory_id: this.attr('', value => value.toUpperCase()),
            location_id: this.attr(null),
            battery: this.attr(null)
        }
    }

    static graphql = {
        all: {
            parameters: {
                unassigned: 'Boolean'
            }
        },
        one: {
            type: 'beacons',
            parameters: {
                id: 'Int!'
            }
        },
        create: {
            type: 'activateBeacon',
            parameters: {
                factory_id: 'String!',
                immediately: 'Boolean'
            }
        },
        addToLocation: {
            type: 'addBeaconsToLocation',
            parameters: {
                location_id: 'Int!',
                beacons: '[String]'
            }
        },
    }
}